<template>
  <base-layout>
    <v-container class="email-sent">
      <v-row>
        <v-col>
          <v-img class="mx-auto" :width="screenType === 'smartphone' ? '120' : '170'" :src="screenType === 'smartphone' ? imgMobile : imgDesktop" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="email-sent-title" :style="{ color: getAssets.colors.form.buttonBackground }">SUCESSO</p>
          <p class="email-sent-subtitle">Um link de redefinição de senha foi enviado para <span class="email-sent-spotlight" :style="{ color: getAssets.colors.form.buttonBackground }">{{ userEmail }}</span>. Acesse esse e-mail para criar sua nova senha!</p>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-4">
        <v-btn class="button-height"  :color="getAssets.colors.form.buttonBackground" :style="{ color: getAssets.colors.form.buttonFont }" @click="$router.push({ path: '/home' })">voltar para o login</v-btn>
      </v-row>
    </v-container>
  </base-layout>
</template>

<script>
import { screenTypeMixin } from '@/mixins/screen-type'
export default {
  components: {
    BaseLayout: () => import('@/components/layout/BaseLayout.vue')
  },
  mixins: [screenTypeMixin],
  computed: {
    userEmail() {
      return this.$store.getters.USER_EMAIL
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    imgMobile() {
      return require('@/assets/recover-success-v1.png')
    },
    imgDesktop() {
      return require('@/assets/recover-success-v2.png')
    }
  }
}
</script>

<style lang="scss">
.email-sent {
  padding: 40px 30px;
  text-align: center;

  p {
    margin-bottom: 10px;
  }

  &-title {
    font-size: 20px;
    font-weight: 700;
  }

  &-subtitle {
    color: #4B525A;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.15px;
    max-width: 460px;
    margin: auto;
  }

  &-spotlight {
    font-weight: 700;
  }
}
</style>
